import { useCallback, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AddIcon from '../../assets/AddIcon'
import ArrowDown from '../../assets/ArrowDown'
import CloseIcon from '../../assets/CloseIcon'
import LocationIcon from '../../assets/LocationIcon'
import ProductReceivingBlack from '../../assets/ProductReceivingBlack'
import TrashIcon from '../../assets/TrashIcon'
import {
  HEADER_CONFIG,
  HEADER_CONST,
  WIZARD_STEPS,
} from '../../common/constant/common-constant'
import {
  ADD_SALES_STAGES,
  CUSTOMER_FIELDS,
  ONLINE_SALES_STAGES,
  PAGE_CONST,
  PAYMENT_DETAILS_FIELDS,
  PAYMENT_MODE_OPTIONS,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PRESCRIPTION_ORDER_MILESTONE,
  PRODUCT_DETAIL_FIELDS,
  SALES_FLOW,
  SALES_TYPE,
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import WizardSteps from '../../components/WizardSteps/WizardSteps'
import MobileHeader from '../Common/Header/MobileHeader'
import SideDrawer from '../Common/SideDrawer/SideDrawer'

import Select from 'react-select'
import CallIcon from '../../assets/CallIcon'
import CheckPrimaryIcon from '../../assets/CheckPrimaryIcon'
import PendingImage from '../../assets/PendingImage'
import SearchIcon from '../../assets/SearchIcon'
import usePagination from '../../common/hooks/usePagination'
import {
  convertToTitleCase,
  formatDate,
  formatTime,
} from '../../common/utils/appUtils'
import currencyFormatter from '../../common/utils/currencyFormatterUtils'
import { formatProductListLabel } from '../../common/utils/productUtils'
import {
  clearDraft,
  loadDraft,
  saveDraft,
} from '../../common/utils/storageUtils'
import Loading from '../../components/Loding/Loading'
import DRAFT_KEYS from '../../draft/Draft'
import {
  addCustomerHelper,
  addProductToSalesOrderHelper,
  cancelSalesHelper,
  confirmOnlineSalesOrderHelper,
  createSalesHelper,
  deleteProductFromSalesOrderHelper,
  deleteSalesOrderHelper,
  getAllSalesOrderHelper,
  getCustomerHelper,
  getProductDetailsByBarcodeHelper,
  getSalesOrderHelper,
  updatePrescriptionOrderHelper,
  updateProductToSalesOrderHelper,
  updateSalesHelper,
} from '../../helper/home-helper'
import { getDeliveryPartnersHelper } from '../../helper/personal-details-helper'
import {
  createSalesAlertAction,
  holdSalesAlertAction,
  newSalesDataAction,
  onlineSalesOrderCancellationAlertAction,
  onlineSalesOrderConfirmationAlertAction,
  salesDataAction,
  updateSalesAlertAction,
} from '../../modules/actions/action'
import AcknowledgeScreen from '../Common/AcknowledgeScreen/AcknowledgeScreen'
import PopupCard from '../Common/PopupCard/PopupCard'
import SaleFilterOptions from './components/SaleFilterOptions'
import SaleStatusTabs from './components/SaleStatusTabs'
import SaleTabContent from './components/SaleTabContent'
import Product from './Product'
import './Sales.scss'
import ViewSales from './ViewSales'

const Sales = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()
  const pagination = usePagination({ initialPage: 1, initialLimit: 50 })
  const [offlineDrawerOpen, setOfflineDrawerOpen] = useState(false)
  const [onlineDrawerOpen, setOnlineDrawerOpen] = useState(false)
  const [onlinePrescriptionDrawerOpen, setOnlinePrescriptionDrawerOpen] =
    useState(false)
  const [wizardState, setWizardState] = useState(undefined)
  const [isViewSalesActive, setViewSalesActive] = useState(false)
  const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [deleteProductPopup, setDeleteProductPopup] = useState(false)
  const [deleteProductId, setDeleteProductId] = useState(null)
  const [addProductActive, setAddProductActive] = useState(false)
  const [createSalesAlert, setCreateSalesAlert] = useState(false)
  const [holdSalesAlert, setHoldSalesAlert] = useState(false)
  const [updateSalesAlert, setUpdateSalesAlert] = useState(false)
  const [onlineSalesConfirmationAlert, setOnlineSalesConfirmationAlert] =
    useState(false)
  const [onlineSalesCancellationAlert, setOnlineSalesCancellationAlert] =
    useState(false)
  const [addedProductVisibleId, setAddedProductVisibleId] = useState({
    id: undefined,
  })
  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.SALES,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => redirect(navigate, PAGE_CONST.HOME),
  })
  const [salesFlow, setSalesFlow] = useState(SALES_FLOW.OFFLINE)
  const [addSalesStage, setAddSalesStage] = useState(
    ADD_SALES_STAGES.CUSTOMER_DETAILS
  )
  const [onlineSalesStage, setOnlineSalesStage] = useState(
    ONLINE_SALES_STAGES.PRODUCT_DETAILS
  )

  const [allSalesData, setAllSalesData] = useState([])
  const [stats, setStats] = useState({})
  const [salesData, setSalesData] = useState({})
  const [customerDetails, setCustomerDetails] = useState(undefined)
  const [productDetails, setProductDetails] = useState({})
  const [productDetailsArray, setProductDetailsArray] = useState([])
  const [paymentDetails, setPaymentDetails] = useState(undefined)
  const [deliveryPartnerOptionList, setDeliveryPartnerOptionList] = useState([])
  const [selectedDeliveryPartner, setSelectedDeliveryPartner] =
    useState(undefined)
  const [loginData, setLoginData] = useState({})
  const [permissions, setPermissions] = useState({})
  const inputRef = useRef()
  const [viewSearch, setViewSearch] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [allSalesFilteredData, setAllSalesFilteredData] = useState(allSalesData)

  const [isUpdateProductLoading, setIsUpdateProductLoading] = useState(false)
  const [isSalesUpdateLoading, setIsSalesUpdateLoading] = useState(false)

  const DRAFT_KEY = DRAFT_KEYS.SALES

  const [filterOptions, setFilterOptions] = useState({
    invoice_number: '',
    limit: 50,
    status: `${SALES_TYPE.DRAFT_HOLD_STATUS_LIST}`,
    past_days: null,
    type: '',
  })

  const fetchSalesData = async (filters) => {
    setIsSalesUpdateLoading(true)
    try {
      // Build request body for the API
      const requestBody = {
        page: filters.page || 1,
        limit: filters.limit || 50,
      }

      // Add status filter if provided
      if (filters.status) {
        requestBody.status = filters.status
      }

      // Add type filter if provided (ONLINE, IN_STORE)
      if (filters.type) {
        requestBody.type = filters.type
      }

      // Add invoice number search if provided
      if (filters.invoice_number) {
        requestBody.invoice_number = filters.invoice_number
      }

      console.log('Fetching sales with filters:', requestBody)

      const res = await getAllSalesOrderHelper(requestBody)
      const { sales_orders, stats, pagination: resPagination } = res

      setStats(stats)
      props.dispatchSalesDataAction(sales_orders)

      if (resPagination?.count) pagination.setTotalItems(resPagination.count)
    } catch (err) {
      console.error('Error loading sales data:', err)
    } finally {
      setIsSalesUpdateLoading(false)
    }
  }

  const updateFilterOptions = (newOptions) => {
    setFilterOptions((prev) => ({
      ...prev,
      ...newOptions,
    }))
    if (newOptions.limit) {
      pagination.changeLimit(newOptions.limit)
    } else {
      pagination.goToPage(1)
    }
  }

  const getAllSalesData = useCallback(async () => {
    fetchSalesData({
      ...filterOptions,
      page: pagination.page,
    })
  }, [pagination.page, pagination.limit, filterOptions])

  const handleDeleteHoldSaleOrder = async (saleId) => {
    try {
      await cancelSalesHelper(saleId)
      getAllSalesData()
    } catch (err) {
      console.error('Error cancelling sales order:', err)
    }
  }

  useEffect(() => {
    getAllSalesData()
  }, [getAllSalesData])

  useEffect(() => {
    if (props?.salesData) {
      setAllSalesData([...props.salesData])
    }
  }, [props.salesData])

  // Frontend filtering based on filterOptions
  useEffect(() => {
    if (!allSalesData || allSalesData.length === 0) {
      setAllSalesFilteredData([])
      return
    }

    let filteredData = [...allSalesData]

    // Filter by status (Confirmed/Draft & Hold/Cancelled tabs)
    if (filterOptions.status) {
      const statusList = filterOptions.status.split(',').map(s => s.trim())
      filteredData = filteredData.filter((sale) => {
        // Map COMPLETED to both COMPLETED and CONFIRMED for "Confirmed" tab
        if (statusList.includes(SALES_TYPE.COMPLETED)) {
          return sale.status === SALES_TYPE.COMPLETED || sale.status === SALES_TYPE.CONFIRMED
        }
        return statusList.includes(sale.status)
      })
    }

    // Filter by type (All/Online/In Store)
    if (filterOptions.type) {
      filteredData = filteredData.filter((sale) => sale.type === filterOptions.type)
    }

    // Filter by invoice number (search)
    if (filterOptions.invoice_number) {
      const searchLower = filterOptions.invoice_number.toLowerCase()
      filteredData = filteredData.filter((sale) =>
        sale.invoice_number?.toLowerCase().includes(searchLower)
      )
    }

    // Filter by customer search term (existing functionality)
    if (searchTerm) {
      filteredData = filteredData.filter((sale) =>
        sale?.customer_mobile_no?.includes(searchTerm)
      )
    }

    console.log('Filtered data:', filteredData.length, 'from', allSalesData.length)
    setAllSalesFilteredData(filteredData)
  }, [allSalesData, filterOptions, searchTerm])

  useEffect(() => {
    if (
      !offlineDrawerOpen &&
      !onlineDrawerOpen &&
      !onlinePrescriptionDrawerOpen &&
      !isViewSalesActive
    ) {
      handleHeaderConfigUpdate(HEADER_CONST.SALES, () =>
        redirect(navigate, PAGE_CONST.HOME)
      )
      return
    }

    setAddProductActive(false)
    handleWizardState(WIZARD_STEPS.STEP_1)
    if (salesFlow === SALES_FLOW.OFFLINE_HOLD)
      setAddSalesStage(ADD_SALES_STAGES.PRODUCT_DETAILS)
    else setAddSalesStage(ADD_SALES_STAGES.CUSTOMER_DETAILS)

    if (offlineDrawerOpen) {
      handleHeaderConfigUpdate(HEADER_CONST.ADD_SALES, () =>
        handleDrawerToggle()
      )
    } else if (onlineDrawerOpen) {
      handleHeaderConfigUpdate(HEADER_CONST.ADD_SALES, () =>
        handleOnlineDrawerToggle()
      )
    } else if (onlinePrescriptionDrawerOpen) {
      handleHeaderConfigUpdate(HEADER_CONST.ADD_SALES, () =>
        handleOnlinePrescriptionDrawerToggle()
      )
    } else if (isViewSalesActive) {
      handleHeaderConfigUpdate(HEADER_CONST.VIEW_SALES, () =>
        setViewSalesActive(!isViewSalesActive)
      )
    }
  }, [
    offlineDrawerOpen,
    onlineDrawerOpen,
    onlinePrescriptionDrawerOpen,
    isViewSalesActive,
  ])

  useEffect(() => {
    let createSalesAlert = props.alert?.createSalesAlert
    let holdSalesAlert = props.alert?.holdSalesAlert
    let updateSalesAlert = props.alert?.updateSalesAlert
    let onlineSalesConfirmationAlert = props.alert.onlineSalesConfirmationAlert
    let onlineSalesCancellationAlert = props.alert.onlineSalesCancellationAlert
    setCreateSalesAlert(createSalesAlert)
    setHoldSalesAlert(holdSalesAlert)
    setUpdateSalesAlert(updateSalesAlert)
    setOnlineSalesConfirmationAlert(onlineSalesConfirmationAlert)
    setOnlineSalesCancellationAlert(onlineSalesCancellationAlert)
  }, [
    props.alert?.createSalesAlert,
    props.alert?.holdSalesAlert,
    props.alert?.updateSalesAlert,
    props.alert?.onlineSalesConfirmationAlert,
    props.alert?.onlineSalesCancellationAlert,
  ])

  useEffect(() => {
    setServerError(undefined)
    switch (addSalesStage) {
      case ADD_SALES_STAGES.CUSTOMER_DETAILS:
        handleWizardState(WIZARD_STEPS.STEP_1)
        break
      case ADD_SALES_STAGES.PRODUCT_DETAILS:
        handleWizardState(WIZARD_STEPS.STEP_2)
        if (productDetailsArray.length <= 0) setAddProductActive(true)
        break
      case ADD_SALES_STAGES.PAYMENT_DETAILS:
        handleWizardState(WIZARD_STEPS.STEP_3)
        handlePaymentDetailsUpdate(
          PAYMENT_DETAILS_FIELDS.AMOUNT,
          getSalesAmount()
        )
        break
      default:
        break
    }
  }, [addSalesStage])

  useEffect(() => {
    setServerError(undefined)
    switch (onlineSalesStage) {
      case ONLINE_SALES_STAGES.PRODUCT_DETAILS:
        handleWizardState(WIZARD_STEPS.STEP_1)
        break
      case ADD_SALES_STAGES.PAYMENT_DETAILS:
        handleWizardState(WIZARD_STEPS.STEP_2)
        handlePaymentDetailsUpdate(
          PAYMENT_DETAILS_FIELDS.AMOUNT,
          getSalesAmount()
        )
        break
      default:
        break
    }
  }, [onlineSalesStage])

  useEffect(() => {
    let totalAmount = getTotalAmount()

    if (totalAmount !== paymentDetails?.[PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT]) {
      handlePaymentDetailsUpdate(
        PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT,
        getTotalAmount()
      )
    }
  }, [
    paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT],
    paymentDetails?.[PAYMENT_DETAILS_FIELDS.VAT],
    paymentDetails?.[PAYMENT_DETAILS_FIELDS.DISCOUNT],
    paymentDetails?.[PAYMENT_DETAILS_FIELDS.TRADE_DISCOUNT_PERCENTAGE],
  ])

  useEffect(() => {
    setLoginData(props.loginData)

    if (props.loginData.permissions) {
      console.log('props.loginData.permissions: ', props.loginData.permissions)

      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.MANAGE_STORE
      )[0]

      console.log('home screen permission: ', permission)
      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  // Restore draft on mount
  useEffect(() => {
    const draft = loadDraft(DRAFT_KEY)
    if (draft) {
      if (draft.customerDetails) setCustomerDetails(draft.customerDetails)
      if (draft.productDetails) setProductDetails(draft.productDetails)
      if (draft.productDetailsArray)
        setProductDetailsArray(draft.productDetailsArray)
      if (draft.paymentDetails) setPaymentDetails(draft.paymentDetails)
      if (draft.addSalesStage) setAddSalesStage(draft.addSalesStage)
    }
  }, [])

  // Persist draft on state change
  useEffect(() => {
    saveDraft(DRAFT_KEY, {
      customerDetails,
      productDetails,
      productDetailsArray,
      paymentDetails,
      addSalesStage,
    })
  }, [
    customerDetails,
    productDetails,
    productDetailsArray,
    paymentDetails,
    addSalesStage,
  ])

  const expandSearch = () => {
    inputRef.current.focus(setViewSearch(true))
  }

  const getProductDetailsByBarcode = (bCode) => {
    setServerError('')
    let barCode =
      bCode || productDetails?.[PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE]
    if (!barCode) {
      return
    }
    getProductDetailsByBarcodeHelper(barCode)
      .then((res) => {
        if (res) {
          let data = {
            ...res,
          }
          setProductDetails(data)
        }
      })
      .catch((err) => {
        setServerError(err)
        setProductDetails({
          [PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE]: barCode,
        })
        // console.log("")
      })
  }

  const handleHeaderConfigUpdate = (title, handleBackFunc) => {
    setHeaderOptions({
      [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
      [HEADER_CONFIG.TITLE]: title,
      [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc(),
    })
  }

  const handleDrawerToggle = () => {
    setOfflineDrawerOpen(!offlineDrawerOpen)
  }

  const handleOnlineDrawerToggle = () => {
    if (onlineDrawerOpen) resetDrawerData()
    setOnlineDrawerOpen(!onlineDrawerOpen)
  }

  const handleOnlinePrescriptionDrawerToggle = () => {
    if (onlinePrescriptionDrawerOpen) resetDrawerData()
    setOnlinePrescriptionDrawerOpen(!onlinePrescriptionDrawerOpen)
  }

  const handleWizardState = (state) => {
    switch (state) {
      case WIZARD_STEPS.STEP_3:
        setWizardState({
          [WIZARD_STEPS.STEP_1]: true,
          [WIZARD_STEPS.STEP_2]: true,
          [WIZARD_STEPS.STEP_3]: false,
        })
        break
      case WIZARD_STEPS.STEP_2:
        setWizardState({
          [WIZARD_STEPS.STEP_1]: true,
          [WIZARD_STEPS.STEP_2]: false,
          [WIZARD_STEPS.STEP_3]: false,
        })
        break
      case WIZARD_STEPS.STEP_1:
        setWizardState({
          [WIZARD_STEPS.STEP_1]: false,
          [WIZARD_STEPS.STEP_2]: false,
          [WIZARD_STEPS.STEP_3]: false,
        })
        break
      default:
        break
    }
  }

  const onOnlineSalesWizardStepClick = (step) => {
    switch (step) {
      case WIZARD_STEPS.STEP_1:
        setOnlineSalesStage(ONLINE_SALES_STAGES.PRODUCT_DETAILS)
        break
      case WIZARD_STEPS.STEP_2:
        setOnlineSalesStage(ONLINE_SALES_STAGES.PAYMENT_DETAILS)
        break
      default:
        break
    }
  }

  const onAddSalesWizardStepClick = (step) => {
    switch (step) {
      case WIZARD_STEPS.STEP_1:
        setAddSalesStage(ADD_SALES_STAGES.CUSTOMER_DETAILS)
        break
      case WIZARD_STEPS.STEP_2:
        setAddSalesStage(ADD_SALES_STAGES.PRODUCT_DETAILS)
        break
      case WIZARD_STEPS.STEP_3:
        setAddSalesStage(ADD_SALES_STAGES.PAYMENT_DETAILS)
        break
      default:
        break
    }
  }

  const checkAddProductValidation = (pDetails) => {
    if (pDetails) {
      if (
        pDetails[PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE] &&
        pDetails[PRODUCT_DETAIL_FIELDS.PRODUCT_UNDERSCORE_ID] &&
        pDetails[PRODUCT_DETAIL_FIELDS.QUANTITY] &&
        pDetails[PRODUCT_DETAIL_FIELDS.DOSE] &&
        parseInt(pDetails?.[PRODUCT_DETAIL_FIELDS.QUANTITY]) > 0 &&
        parseInt(pDetails?.[PRODUCT_DETAIL_FIELDS.QUANTITY]) <=
          parseInt(
            pDetails?.[PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS]?.[
              PRODUCT_DETAIL_FIELDS.STOCK
            ]
          )
      )
        return true
    }

    if (
      pDetails?.id &&
      parseInt(pDetails?.[PRODUCT_DETAIL_FIELDS.QUANTITY]) > 0
    ) {
      return true
    }

    return false
  }

  const handleAddProductClick = async () => {
    // Early return for invalid state
    if (!checkAddProductValidation(productDetails)) {
      setIsFieldErrorVisible(true)
      return
    }

    if (
      salesData?.id &&
      productDetails?.product_id &&
      productDetails?.selected_batch_details
    ) {
      const { batch_number } = productDetails.selected_batch_details
      const newAddedProduct = await addProductToSalesOrderHelper(
        salesData.id,
        productDetails.product_id,
        batch_number,
        { quantity: Number(productDetails.quantity) }
      )
    }

    // Update array: either update existing product or add new one
    setProductDetailsArray((prevArray) => {
      const existingIndex = prevArray.findIndex(
        (product) =>
          product.product_batch_inventory_id ===
          productDetails.product_batch_inventory_id
      )

      if (existingIndex !== -1) {
        // Update existing product quantity
        const updatedArray = [...prevArray]
        updatedArray[existingIndex] = {
          ...updatedArray[existingIndex],
          quantity: `${
            (Number(updatedArray[existingIndex].quantity) || 0) +
            (Number(productDetails.quantity) || 0)
          }`,
        }

        return updatedArray
      } else {
        // Add new product
        return [...prevArray, productDetails]
      }
    })

    // Reset form state
    setProductDetails({})
    setAddProductActive(false)
  }

  const handleUpdateProductSubmit = async (product) => {
    if (!checkAddProductValidation(product)) {
      setIsFieldErrorVisible(true)
      return
    }

    if (
      !salesData?.id ||
      !product?.id ||
      !product?.quantity ||
      Number(product?.quantity) < 1
    ) {
      console.log('Unable to update product')
      return
    }

    setIsUpdateProductLoading(true)

    const updateProduct = await updateProductToSalesOrderHelper(
      salesData.id,
      product.id,
      {
        quantity: Number(product.quantity),
      }
    )

    setIsUpdateProductLoading(false)
  }

  const handleRemoveProductClick = async (product) => {
    if (salesData?.id && product?.id) {
      const deletedProduct = await deleteProductFromSalesOrderHelper(
        salesData.id,
        product.id
      )
    }

    const updatedArray = productDetailsArray.filter(
      (item) =>
        item.product_batch_inventory_id !== product.product_batch_inventory_id
    )

    setProductDetailsArray(updatedArray)
    setDeleteProductId(null)
    setDeleteProductPopup(false)
  }

  const handleProductDetailsUpdate = (id, key, value) => {
    setProductDetails((prevDetails) => {
      return {
        ...prevDetails,
        [key]: value,
      }
    })
  }

  const handleExistingProductUpdate = (id = undefined, key, value) => {
    let pDetails = productDetailsArray || []

    let productIndex = pDetails.findIndex((obj) => obj.product_id === id)
    if (productIndex > -1) {
      pDetails[productIndex][key] = value
    } else {
      let newProduct = {
        id: Math.floor(Math.random() * 100),
        [key]: value,
      }

      pDetails.push(newProduct)
    }

    setProductDetailsArray([...pDetails])
  }
  // const handleExistingProductUpdate = (id, key, value) => {
  //   console.log('Updating product:', id, key, value)
  //   console.log('Current addedProductVisibleId:', addedProductVisibleId)

  //   setProductDetailsArray((prevProducts) => {
  //     return prevProducts.map((product) => {
  //       if (product.product_id === id) {
  //         return {
  //           ...product,
  //           [key]: value,
  //         }
  //       }
  //       return product
  //     })
  //   })

  //   console.log('After update, addedProductVisibleId:', addedProductVisibleId)
  // }
  const checkValidation = () => {
    // return true;
    if (addSalesStage === ADD_SALES_STAGES.CUSTOMER_DETAILS) {
      if (customerDetails) {
        if (
          customerDetails[CUSTOMER_FIELDS.NAME] &&
          customerDetails[CUSTOMER_FIELDS.PHONE_NUMBER] &&
          customerDetails[CUSTOMER_FIELDS.BILLING_ADDRESS] &&
          customerDetails[CUSTOMER_FIELDS.SHIPPING_ADDRESS]
        ) {
          return true
        }
      }

      return false
    } else if (addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS) {
      if (productDetailsArray && productDetailsArray.length > 0) {
        let allValid = productDetailsArray.every((product) => {
          return checkAddProductValidation(product)
        })

        if (allValid) return true

        return false
      }
    } else if (addSalesStage === ADD_SALES_STAGES.PAYMENT_DETAILS) {
      if (paymentDetails) {
        if (
          paymentDetails[PAYMENT_DETAILS_FIELDS.AMOUNT] &&
          // paymentDetails[PAYMENT_DETAILS_FIELDS.DISCOUNT] &&
          // && paymentDetails[PAYMENT_DETAILS_FIELDS.TRADE_DISCOUNT]
          // paymentDetails[PAYMENT_DETAILS_FIELDS.VAT] &&
          paymentDetails[PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT]

          // && paymentDetails[PAYMENT_DETAILS_FIELDS.RECEIVED_BY]
        ) {
          if (
            paymentDetails[PAYMENT_DETAILS_FIELDS.PAYMENT_MODE] === 'CASH_CARD'
              ? parseFloat(
                  paymentDetails[PAYMENT_DETAILS_FIELDS.AMOUNT_CARD] || 0
                ) +
                  parseFloat(
                    paymentDetails[PAYMENT_DETAILS_FIELDS.AMOUNT_CASH] || 0
                  ) ===
                paymentDetails[PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT]
              : true
          ) {
            return true
          }
        }
      }

      return false
    }
  }

  const handleNextClick = async () => {
    const isValidState = checkValidation()
    if (!isValidState) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)

    switch (addSalesStage) {
      case ADD_SALES_STAGES.CUSTOMER_DETAILS:
        console.log('customer Details: ', customerDetails)

        if (!customerDetails.id) {
          try {
            await addCustomer()
          } catch (errMsg) {
            setServerError(errMsg)
            return
          }
        }

        setAddSalesStage(ADD_SALES_STAGES.PRODUCT_DETAILS)
        break
      case ADD_SALES_STAGES.PRODUCT_DETAILS:
        console.log('Product Details: ', productDetailsArray)
        setAddSalesStage(ADD_SALES_STAGES.PAYMENT_DETAILS)
        break
      case ADD_SALES_STAGES.PAYMENT_DETAILS:
        if (salesFlow === SALES_FLOW.OFFLINE_HOLD) handleUpdateSales()
        else handleCreateSales()
        break
      default:
        break
    }
  }

  const handleOnlineOrderNextClick = () => {
    if (onlineSalesStage === ONLINE_SALES_STAGES.PRODUCT_DETAILS) {
      setOnlineSalesStage(ONLINE_SALES_STAGES.PAYMENT_DETAILS)
      // handleWizardState(WIZARD_STEPS.STEP_2)

      // Uncomment this block to enable delivery partner selection
      // getDeliveryPartnerList()
    } else if (onlineSalesStage === ONLINE_SALES_STAGES.PAYMENT_DETAILS) {
      // Uncomment this block to enable delivery partner selection
      // if (!selectedDeliveryPartner) {
      //     setIsFieldErrorVisible(true)
      //     return
      // }

      confirmOnlineSalesOrder(SALES_TYPE.CONFIRMED)
    }
  }

  const handleOnlineOrderWithPrescriptionNextClick = () => {
    if (onlineSalesStage === ONLINE_SALES_STAGES.PRODUCT_DETAILS) {
      if (productDetailsArray?.length > 0) {
        setOnlineSalesStage(ONLINE_SALES_STAGES.PAYMENT_DETAILS)
      }
      // handleWizardState(WIZARD_STEPS.STEP_2)
      // getDeliveryPartnerList()
    } else if (onlineSalesStage === ONLINE_SALES_STAGES.PAYMENT_DETAILS) {
      let data = {
        productDetails: productDetailsArray,
        paymentDetails: paymentDetails,
        orderId: salesData?.id,
      }

      console.log('sales with prescription data', data)

      updatePrescriptionOrderHelper(data)
        .then((res) => {
          console.log(res)

          props.updateSalesAlertAction(true)
          setTimeout(() => {
            props.updateSalesAlertAction(false)
          }, 5000)

          getAllSalesData()
          resetDrawerData()
          handleOnlinePrescriptionDrawerToggle()
        })
        .catch((errMsg) => {
          setServerError(errMsg)
        })
    }
  }

  const confirmOnlineSalesOrder = (status) => {
    let data = {
      id: salesData.id,
      deliveryPartnerId: selectedDeliveryPartner && selectedDeliveryPartner.id,
      status: status,
    }

    confirmOnlineSalesOrderHelper(data)
      .then((res) => {
        console.log(res)

        if (status === SALES_TYPE.CANCELLED) {
          props.onlineSalesOrderCancellationAlertAction(true)
          setTimeout(() => {
            props.onlineSalesOrderCancellationAlertAction(false)
          }, 5000)
        } else {
          props.onlineSalesOrderConfirmationAlertAction(true)
          setTimeout(() => {
            props.onlineSalesOrderConfirmationAlertAction(false)
          }, 5000)
        }

        getAllSalesData()
        resetDrawerData()
        handleOnlineDrawerToggle()
      })
      .catch((err) => {
        setServerError(err)
      })
  }

  const getDeliveryPartnerList = () => {
    getDeliveryPartnersHelper()
      .then((res) => {
        console.log('dpol res: ', res)
        setDeliveryPartnerOptionList(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getCustomer = () => {
    if (
      ![10, 11].includes(
        customerDetails?.[CUSTOMER_FIELDS.PHONE_NUMBER]?.length
      )
    ) {
      return
    }

    getCustomerHelper(customerDetails)
      .then((res) => {
        if (res) {
          setCustomerDetails({
            ...res,
          })
        }

        console.log(res)
      })
      .catch(() => {})
  }

  const addCustomer = async () => {
    let data = { ...customerDetails }

    try {
      let res = await addCustomerHelper(data)
      console.log(res)

      setCustomerDetails({
        ...customerDetails,
        id: res.id,
      })
    } catch (errMsg) {
      throw errMsg
    }
  }

  const updateCustomerDetails = (type, value) => {
    let cDetails = customerDetails
    if (type === CUSTOMER_FIELDS.PHONE_NUMBER) {
      cDetails = {}
    }

    if (type === CUSTOMER_FIELDS.BILLING_ADDRESS) {
      cDetails[CUSTOMER_FIELDS.SHIPPING_ADDRESS] = value
    }

    setCustomerDetails({
      ...cDetails,
      [type]: value,
    })
  }

  const handleHoldSales = () => {
    const isValidState = checkValidation()
    if (!isValidState) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)

    handleCreateSales(SALES_TYPE.HOLD)
  }

  const handlePaymentDetailsUpdate = (key, value) => {
    setPaymentDetails((prevDetails) => {
      let updatedDetails = { ...prevDetails }

      // Update the payment details based on the key and value
      if (key === PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT) {
        let discountPercentage = parseFloat(
          (value / prevDetails[PAYMENT_DETAILS_FIELDS.AMOUNT]) * 100
        ).toFixed(2)
        updatedDetails = {
          ...updatedDetails,
          [PAYMENT_DETAILS_FIELDS.DISCOUNT]: discountPercentage,
        }
      } else if (key === PAYMENT_DETAILS_FIELDS.DISCOUNT) {
        let discountAmount = parseFloat(
          (value / 100) * prevDetails[PAYMENT_DETAILS_FIELDS.AMOUNT]
        ).toFixed(2)
        updatedDetails = {
          ...updatedDetails,
          [PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT]: discountAmount,
        }
      }

      // Finally, update the key that was passed in
      updatedDetails[key] = value
      console.log('Updated payment details:', updatedDetails)
      return updatedDetails
    })

    // setPaymentDetails({
    //     ...paymentDetails,
    //     [key]: value
    // })
  }

  const handleCreateSales = (status) => {
    let data = {
      customerDetails: customerDetails,
      productDetails: productDetailsArray,
      paymentDetails: paymentDetails,
    }

    if (status) data.status = status

    console.log(data)
    setIsSalesUpdateLoading(true)
    // return;

    createSalesHelper(data)
      .then((res) => {
        console.log(res)

        if (status === SALES_TYPE.HOLD) {
          props.holdSalesAlertAction(true)
          setTimeout(() => {
            props.holdSalesAlertAction(false)
          }, 5000)
        } else {
          props.createSalesAlertAction(true)
          setTimeout(() => {
            props.createSalesAlertAction(false)
          }, 5000)
        }

        setIsSalesUpdateLoading(false)
        getAllSalesData()
        resetDrawerData()
        handleDrawerToggle()
        clearDraft(DRAFT_KEY)
      })
      .catch((errMsg) => {
        setIsSalesUpdateLoading(false)
        setServerError(errMsg)
      })
  }

  const handleUpdateSales = (status) => {
    let data = {
      id: salesData.id,
      productDetails: productDetailsArray,
      paymentDetails: paymentDetails,
    }

    if (status && status === SALES_TYPE.HOLD) {
      data.status = status
    }

    console.log(data)

    setIsSalesUpdateLoading(true)

    updateSalesHelper(data)
      .then((res) => {
        console.log(res)

        props.updateSalesAlertAction(true)
        setTimeout(() => {
          props.updateSalesAlertAction(false)
        }, 5000)

        getAllSalesData()
        resetDrawerData()
        handleDrawerToggle()
        setIsSalesUpdateLoading(false)
        clearDraft(DRAFT_KEY)
      })
      .catch((errMsg) => {
        setServerError(errMsg)
        setIsSalesUpdateLoading(false)
      })
  }

  const handleCancelSales = (id) => {
    console.log('in handleCancelSales flow')
  }

  const resetDrawerData = () => {
    setCustomerDetails({})
    setSalesData({})
    setProductDetails({})
    setProductDetailsArray([])
    setAddSalesStage(undefined)
    setPaymentDetails({})
    setOnlineSalesStage(ONLINE_SALES_STAGES.PRODUCT_DETAILS)
    setSalesFlow(SALES_FLOW.OFFLINE)
    setAddProductActive(false)
  }

  const handleSalesCardClickFlow = (salesData, status) => {
    if (
      status === SALES_TYPE.HOLD ||
      (!SALES_TYPE.NON_HOLD_STATUS_LIST.includes(status) &&
        !SALES_TYPE.CONFIRMED_LIST.includes(status))
    ) {
      // For HOLD and Draft orders (both IN_STORE and ONLINE), navigate to edit form
      navigate(`/home/sales/edit/${salesData.id}`)
    } else {
      // For completed/confirmed orders, show the view drawer
      setViewSalesActive(true)
    }
  }

  const getSaleDetails = (id, status) => {
    getSalesOrderHelper(id)
      .then((res) => {
        console.log('res so: ', res)
        setSalesData(res)

        handleSalesCardClickFlow(res, status)
        // TODO: prescription logic
      })
      .catch((err) => {
        console.log('err so: ', err)
      })

    return null
  }

  const setHoldOrderDatainState = (sData) => {
    let cDetails = {
      id: sData.customer?.id,
      [CUSTOMER_FIELDS.NAME]: sData.customer?.name,
      [CUSTOMER_FIELDS.PHONE_NUMBER]: sData.customer?.mobile_no,
      [CUSTOMER_FIELDS.BILLING_ADDRESS]: sData.customer?.shipping_address,
      [CUSTOMER_FIELDS.SHIPPING_ADDRESS]: sData.customer?.billing_address,
    }

    sData?.product_details?.map((product) => {
      product[PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS] =
        product?.inventory || undefined
      product.inventory = []
    })

    let pdArray = sData.product_details

    setCustomerDetails(cDetails)
    setProductDetailsArray(pdArray)
  }

  const handleAddSalesClick = () => {
    // Navigate to the new sales form page
    navigate('/home/sales/new')
  }

  const getSalesAmount = () => {
    let pdArray = productDetailsArray

    let amount = 0

    pdArray.map((productDetail) => {
      amount +=
        parseFloat(
          productDetail?.[PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS]?.[
            PRODUCT_DETAIL_FIELDS.RATE_PER_UNIT
          ]
        ).toFixed(2) *
        parseFloat(productDetail[PRODUCT_DETAIL_FIELDS.QUANTITY]).toFixed(2)
    })

    return amount
  }

  const getDiscountedAmount = () => {
    let initialAmount = paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT] || 0

    let discountPercentage =
      paymentDetails?.[PAYMENT_DETAILS_FIELDS.DISCOUNT] || 0

    return parseFloat((discountPercentage / 100) * initialAmount).toFixed(2)
  }

  const getTradeDiscountedAmount = () => {
    let initialAmount = paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT] || 0

    let tradeDiscountPercentage =
      paymentDetails?.[PAYMENT_DETAILS_FIELDS.TRADE_DISCOUNT_PERCENTAGE] || 0

    return parseFloat((tradeDiscountPercentage / 100) * initialAmount).toFixed(
      2
    )
  }

  const getVatAmount = () => {
    let amount = paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT] || 0
    let discount =
      paymentDetails?.[PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT] || 0 || 0
    let tradeDiscount = getTradeDiscountedAmount() || 0

    let remainingAmount = amount - discount - tradeDiscount

    let vatPercentage = paymentDetails?.[PAYMENT_DETAILS_FIELDS.VAT] || 0

    return parseFloat((vatPercentage / 100) * remainingAmount).toFixed(2)
  }

  const getTotalAmount = () => {
    let initialAmount = paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT]
    let discountedAmount = parseFloat(
      paymentDetails?.[PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT] || 0
    )
    let tradeDiscountedAmount = parseFloat(getTradeDiscountedAmount())
    let vat = parseFloat(getVatAmount())

    let remainingAmount =
      initialAmount - discountedAmount - tradeDiscountedAmount + vat || 0

    console.log(
      'iniAmo, discountedAmount, tradeDiscountedAmount, vat, remainingAmount',
      initialAmount,
      discountedAmount,
      tradeDiscountedAmount,
      vat,
      remainingAmount
    )
    return Number(parseFloat(remainingAmount).toFixed(2))
  }

  const getAlertText = () => {
    if (createSalesAlert) return 'Sales Order created Successfully!'
    else if (holdSalesAlert) return 'Sales Order put on Hold Successfully!'
    else if (updateSalesAlert) return 'Sales Order updated Successfully!'
    else if (onlineSalesConfirmationAlert)
      return 'Online Sales Order Confirmed Successfully'
    else if (onlineSalesCancellationAlert)
      return 'Online Sales Order Cancelled Successfully'
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {(createSalesAlert ||
        holdSalesAlert ||
        updateSalesAlert ||
        onlineSalesConfirmationAlert ||
        onlineSalesCancellationAlert) && (
        <AcknowledgeScreen
          icon={<CheckPrimaryIcon />}
          main={getAlertText()}
          sub="Lorem ipsum dolor sit amet consectetur. Ligula ut volutpat morbi ullamcorper"
          success
          alertType="success"
          alertMessage={getAlertText()}
        />
      )}
      <div className="pageBodyRightPanel">
        {isMobile && (
          <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
            <div
              className={'formGroup mb-0 searchBar expand'}
              onClick={expandSearch}
              onBlur={() => setViewSearch(false)}
            >
              <input
                ref={inputRef}
                type="text"
                className="formControl"
                placeholder="Search By Customer Number"
                onChange={(e) => setSearchTerm(e?.target?.value)}
              />
              <div className={`searchIcon`}>
                <SearchIcon />
              </div>
            </div>
            <button
              className="animated zoomIn btn btnPrimary ml-2"
              onClick={handleAddSalesClick}
            >
              <AddIcon />
            </button>
          </div>
        )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">Sales</div>
            <div className="addProductBtn dFlex aiCenter">
              <div
                className={`formGroup mb-0 searchBar expand`}
                onClick={expandSearch}
                onBlur={() => setViewSearch(false)}
              >
                <input
                  ref={inputRef}
                  type="text"
                  className="formControl"
                  placeholder="Search By Customer Number"
                  onChange={(e) => setSearchTerm(e?.target?.value)}
                />
                <div className={`searchIcon`}>
                  <SearchIcon />
                </div>
              </div>
              {
                <button
                  className="btn btnPrimary ml-4"
                  onClick={handleAddSalesClick}
                >
                  ADD
                </button>
              }
              <div className="pointer ml-4" onClick={() => props.onClose()}>
                <CloseIcon />
              </div>
            </div>
          </div>
        )}
        <div className="consolidateStrip dFlex jcSpaceBetween aiCenter">
          <div className="consolidateDataIcon dFlex">
            <ProductReceivingBlack />
          </div>
          <div className="consolidateDataText">
            Sales ({stats?.month_name || '-'}) <small>BDT</small>
          </div>
          <div className="consolidateData">
            {currencyFormatter(stats?.total_amount?.total_amount)}
          </div>
        </div>
        <SaleFilterOptions
          filterOptions={filterOptions}
          updateFilterOptions={updateFilterOptions}
        />

        <div className="salesWrapper mt-5">
          <SaleStatusTabs
            filterOptions={filterOptions}
            updateFilterOptions={updateFilterOptions}
          />
          {isSalesUpdateLoading && <Loading />}

          {!isSalesUpdateLoading && (
            <SaleTabContent
              allSalesFilteredData={allSalesFilteredData}
              getSaleDetails={getSaleDetails}
              handleDeleteHoldSaleOrder={handleDeleteHoldSaleOrder}
              pagination={pagination}
              refreshData={getAllSalesData}
            />
          )}
        </div>
        <ViewSales
          open={isViewSalesActive}
          handleDrawerToggle={() => setViewSalesActive(!isViewSalesActive)}
          data={salesData}
        />
        {/** offline sales order sideDrawer */}
        {console.log('rojon salesFlow: ', salesFlow)}
        {offlineDrawerOpen && (
          <SideDrawer
            handleDrawerToggle={handleDrawerToggle}
            open={offlineDrawerOpen}
            drawerButton={
              permissions?.features?.[PERMISSION_FEATURE.SALES] ===
                PERMISSION_TYPE.MANAGE ||
              !(
                addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS &&
                !addProductActive
              )
            }
            holdButton={
              addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS &&
              !addProductActive &&
              productDetailsArray?.length > 0
              // && salesFlow !== SALES_FLOW.OFFLINE_HOLD // TODO: add a check of online hold also
            }
            handleHoldClick={() => {
              if (salesFlow === SALES_FLOW.OFFLINE_HOLD) {
                handleUpdateSales(SALES_TYPE.HOLD)
              } else {
                handleHoldSales()
              }
            }}
            drawerHeading="Add New Sales"
            buttonText={
              addProductActive &&
              addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS
                ? 'Save'
                : 'Next'
            }
            handleClick={
              addProductActive &&
              addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS
                ? () => handleAddProductClick()
                : () => handleNextClick()
            }
            isLoading={isSalesUpdateLoading}
          >
            <WizardSteps
              wizardState={wizardState}
              onStepClick={(step) => onAddSalesWizardStepClick(step)}
            />
            <div className="wizardFieldset">
              {serverError && (
                <div class="invalidFeedback mb-4">{serverError}</div>
              )}
              {addSalesStage === ADD_SALES_STAGES.CUSTOMER_DETAILS && (
                <form onSubmit={(e) => e.preventDefault()} className="mt-5">
                  <div className="formHeading">Customer Details</div>
                  <div className="formInline dFlex flexNowrap">
                    <div className="formGroup formFloating fgrow1 maxWidth">
                      <select className="formSelect" id="floatingSelect">
                        {/* <option value="1">+91</option> */}
                        <option value="2">+88</option>
                      </select>
                      <label for="floatingSelect">Country</label>
                      {false && (
                        <div className="invalidFeedback">
                          Please choose country code.
                        </div>
                      )}
                    </div>
                    <div className="formGroup formFloating ml-4 fgrow1">
                      <input
                        type="text"
                        className="formControl"
                        id="phone"
                        placeholder="Phone"
                        value={
                          customerDetails?.[CUSTOMER_FIELDS.PHONE_NUMBER] || ''
                        }
                        onChange={(e) => {
                          updateCustomerDetails(
                            CUSTOMER_FIELDS.PHONE_NUMBER,
                            e.target.value
                          )
                        }}
                        onBlur={(e) => getCustomer()}
                        required
                      />
                      <label for="phone">Phone</label>
                      {isFieldErrorVisible &&
                        !customerDetails?.[CUSTOMER_FIELDS.PHONE_NUMBER] && (
                          <div className="invalidFeedback">
                            Please select a valid Phone.
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="formGroup formFloating">
                    <input
                      type="text"
                      className="formControl"
                      id="name"
                      placeholder="Name"
                      value={customerDetails?.[CUSTOMER_FIELDS.NAME] || ''}
                      onChange={(e) =>
                        updateCustomerDetails(
                          CUSTOMER_FIELDS.NAME,
                          e.target.value
                        )
                      }
                      required
                    />
                    <label for="address">Name</label>
                    {isFieldErrorVisible &&
                      !customerDetails?.[CUSTOMER_FIELDS.NAME] && (
                        <div className="invalidFeedback">
                          Please enter a valid Name.
                        </div>
                      )}
                  </div>
                  <div className="formGroup formFloating">
                    <input
                      type="text"
                      className="formControl"
                      id="billingAddress"
                      placeholder="Address"
                      value={
                        customerDetails?.[CUSTOMER_FIELDS.BILLING_ADDRESS] || ''
                      }
                      onChange={(e) =>
                        updateCustomerDetails(
                          CUSTOMER_FIELDS.BILLING_ADDRESS,
                          e.target.value
                        )
                      }
                      required
                    />
                    <label for="address">Address</label>
                    {isFieldErrorVisible &&
                      !customerDetails?.[CUSTOMER_FIELDS.BILLING_ADDRESS] && (
                        <div className="invalidFeedback">
                          Please enter a valid Address.
                        </div>
                      )}
                  </div>
                </form>
              )}
              {addSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS && (
                <>
                  <div className="addedProductsListWrap">
                    <ul className="addedProductsList">
                      {/* {productDetailsArray?.length > 0 &&
                        productDetailsArray.map((product) => {
                          return (
                            <li className="addedProduct">
                              <div className="dFlex jcSpaceBetween aiCenter">
                                <div className="addedProductName">
                                  {
                                    product?.[
                                      PRODUCT_DETAIL_FIELDS.PRODUCT_NAME
                                    ]
                                  }
                                </div>
                                <div className="addedProductAction dFlex">
                                  <div
                                    className="trashIcon"
                                    onClick={() =>
                                      setDeleteProductId(
                                        product.product_batch_inventory_id
                                      )
                                    }
                                  >
                                    <TrashIcon />
                                  </div>

                                  <div
                                    className={`toggleArrow ${
                                      product.product_batch_inventory_id ===
                                      addedProductVisibleId
                                        ? 'show'
                                        : 'hide'
                                    }`}
                                    onClick={() => {
                                      if (
                                        product.product_batch_inventory_id ===
                                        addedProductVisibleId
                                      )
                                        setAddedProductVisibleId(undefined)
                                      else
                                        setAddedProductVisibleId(
                                          product.product_batch_inventory_id
                                        )
                                    }}
                                  >
                                    <ArrowDown />
                                  </div>
                                </div>
                              </div>
                              {deleteProductId ===
                                product.product_batch_inventory_id && (
                                <PopupCard
                                  header="Delete selected Product?"
                                  body="Lorem ipsum dolor sit t consectetur. Nulla bibendum ac ornare sodales.?"
                                >
                                  <button
                                    className="btn btnPrimaryOutlined dFlex"
                                    onClick={() => setDeleteProductId(null)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btnPrimary dFlex"
                                    onClick={() =>
                                      handleRemoveProductClick(product)
                                    }
                                  >
                                    Delete
                                  </button>
                                </PopupCard>
                              )}
                              {addedProductVisibleId ===
                                product.product_batch_inventory_id && (
                                <Product
                                  isFieldErrorVisible={isFieldErrorVisible}
                                  handleProductUpdate={(id, key, value) => {
                                    setServerError(undefined)
                                    handleExistingProductUpdate(id, key, value)
                                  }}
                                  handleUpdateProductSubmit={
                                    handleUpdateProductSubmit
                                  }
                                  isUpdateProductLoading={
                                    isUpdateProductLoading
                                  }
                                  product={product}
                                  isBarcodeDisabled={true}
                                />
                              )}
                            </li>
                          )
                        })} */}

                      {productDetailsArray?.length > 0 &&
                        productDetailsArray.map((product) => {
                          return (
                            <li className="addedProduct">
                              <div className="dFlex jcSpaceBetween aiCenter">
                                <div className="addedProductName">
                                  {formatProductListLabel({
                                    name: product?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME],
                                    size: product?.size,
                                    dose: product?.[PRODUCT_DETAIL_FIELDS.DOSE],
                                    strength: product?.strength,
                                    category: product?.category || product?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY],
                                  })}
                                </div>
                                <div className="addedProductAction dFlex">
                                  <div
                                    className="trashIcon"
                                    onClick={() =>
                                      setDeleteProductId(
                                        product.product_batch_inventory_id
                                      )
                                    }
                                  >
                                    <TrashIcon />
                                  </div>

                                  <div
                                    className={`toggleArrow ${
                                      product.product_id ===
                                      addedProductVisibleId
                                        ? 'show'
                                        : 'hide'
                                    }`}
                                    onClick={() => {
                                      if (
                                        product.product_id ===
                                        addedProductVisibleId
                                      )
                                        setAddedProductVisibleId(undefined)
                                      else
                                        setAddedProductVisibleId(
                                          product.product_id
                                        )
                                    }}
                                  >
                                    <ArrowDown />
                                  </div>
                                </div>
                              </div>

                              {deleteProductId ===
                                product.product_batch_inventory_id && (
                                <PopupCard
                                  header="Delete selected Product?"
                                  body="Lorem ipsum dolor sit t consectetur. Nulla bibendum ac ornare sodales.?"
                                >
                                  <button
                                    className="btn btnPrimaryOutlined dFlex"
                                    onClick={() => setDeleteProductId(null)}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    className="btn btnPrimary dFlex"
                                    onClick={() =>
                                      handleRemoveProductClick(product)
                                    }
                                  >
                                    Delete
                                  </button>
                                </PopupCard>
                              )}

                              {addedProductVisibleId === product.product_id && (
                                <Product
                                  isFieldErrorVisible={isFieldErrorVisible}
                                  handleProductUpdate={(id, key, value) => {
                                    setServerError(undefined)
                                    handleExistingProductUpdate(id, key, value)
                                  }}
                                  handleUpdateProductSubmit={
                                    handleUpdateProductSubmit
                                  }
                                  isUpdateProductLoading={
                                    isUpdateProductLoading
                                  }
                                  product={product}
                                  isBarcodeDisabled={true}
                                />
                              )}
                            </li>
                          )
                        })}

                      {addProductActive && (
                        <li className="addedProduct">
                          <Product
                            isFieldErrorVisible={isFieldErrorVisible}
                            handleProductUpdate={(id, key, value) => {
                              setServerError(undefined)

                              handleProductDetailsUpdate(id, key, value)
                            }}
                            clearProduct={() => {
                              setProductDetails(undefined)
                              setAddProductActive(false)
                            }}
                            getProductDetailsByBarcode={(barCode) =>
                              getProductDetailsByBarcode(barCode)
                            }
                            updateProductDetails={(pDetails) =>
                              setProductDetails(pDetails)
                            }
                            product={productDetails}
                          />
                        </li>
                      )}
                    </ul>
                  </div>
                  {!addProductActive && (
                    <div
                      className="addItemButton"
                      onClick={() => setAddProductActive(true)}
                    >
                      <button className="btn btnPrimary dFlex">
                        <AddIcon />
                      </button>
                    </div>
                  )}
                </>
              )}
              {addSalesStage === ADD_SALES_STAGES.PAYMENT_DETAILS && (
                <form>
                  <div className="formGroup formFloating">
                    <textarea
                      rows="2"
                      type="text"
                      className="formControl"
                      id="notes"
                      value={paymentDetails?.[PAYMENT_DETAILS_FIELDS.NOTES]}
                      onChange={(e) =>
                        handlePaymentDetailsUpdate(
                          PAYMENT_DETAILS_FIELDS.NOTES,
                          e.target.value
                        )
                      }
                      required
                    ></textarea>
                    <label for="notes">Notes</label>
                    {false && (
                      <div className="invalidFeedback">Please enter notes.</div>
                    )}
                  </div>
                  <div className="formGroup formFloating formInputText">
                    <div className="preInputGroup backColor">
                      <div className="preInputText">BDT</div>
                    </div>
                    <input
                      type="text"
                      className="formControl"
                      id="email"
                      placeholder="Amount(BDT)"
                      value={paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT]}
                      readOnly={true}
                      onChange={(e) =>
                        handlePaymentDetailsUpdate(
                          PAYMENT_DETAILS_FIELDS.AMOUNT,
                          e.target.value
                        )
                      }
                      required
                    />
                    <label for="address">Amount(BDT)</label>
                    {false && (
                      <div className="invalidFeedback">
                        Please enter Amount(BDT).
                      </div>
                    )}
                  </div>
                  <div className="formInline dFlex flexNowrap">
                    <div className="formGroup formFloating formInputText">
                      <div className="preInputGroup backColor">
                        <div className="preInputText">%</div>
                      </div>
                      <input
                        type="text"
                        className="formControl"
                        id="amount"
                        placeholder="Discount"
                        value={
                          paymentDetails?.[PAYMENT_DETAILS_FIELDS.DISCOUNT]
                        }
                        onChange={(e) =>
                          handlePaymentDetailsUpdate(
                            PAYMENT_DETAILS_FIELDS.DISCOUNT,
                            e.target.value
                          )
                        }
                        required
                      />
                      <label for="amount">Discount(%)</label>
                      {false && (
                        <div class="invalidFeedback">
                          Please enter a valid Discount.
                        </div>
                      )}
                    </div>

                    <div className="formGroup formFloating formInputText fgrow1 ml-4">
                      <div className="preInputGroup backColor">
                        <div className="preInputText">BDT</div>
                      </div>
                      <input
                        type="text"
                        className="formControl"
                        id="amount"
                        placeholder="Discount"
                        value={
                          paymentDetails?.[
                            PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT
                          ]
                        }
                        onChange={(e) =>
                          handlePaymentDetailsUpdate(
                            PAYMENT_DETAILS_FIELDS.DISCOUNT_AMOUNT,
                            e.target.value
                          )
                        }
                        required
                      />
                      <label for="amount">Discount(BDT)</label>
                      {false && (
                        <div class="invalidFeedback">
                          Please enter a valid Discount.
                        </div>
                      )}
                    </div>

                    {/* <div className="amountPercentage">
                                            <div className="currencyType">
                                                BDT
                                            </div>
                                            <div className="currencyValue">
                                                {getDiscountedAmount()}
                                            </div>
                                        </div> */}
                  </div>
                  {/* <div className="formInline dFlex flexNowrap">
                                    <div className="formGroup formFloating formInputText">
                                        <div className="preInputGroup backColor">
                                            <div className="preInputText">
                                                %
                                            </div>
                                        </div>
                                        <input
                                            type="text"
                                            className="formControl"
                                            id="amount"
                                            placeholder="Trade Discount"
                                            value={
                                                paymentDetails?.[
                                                    PAYMENT_DETAILS_FIELDS
                                                        .TRADE_DISCOUNT_PERCENTAGE
                                                ]
                                            }
                                            onChange={e =>
                                                handlePaymentDetailsUpdate(
                                                    PAYMENT_DETAILS_FIELDS.TRADE_DISCOUNT_PERCENTAGE,
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                        <label for="amount">
                                            Trade Discount(%)
                                        </label>
                                        {false && (
                                            <div class="invalidFeedback">
                                                Please enter a valid Trade
                                                Discount.
                                            </div>
                                        )}
                                    </div>
                                    <div className="amountPercentage">
                                        <div className="currencyType">BDT</div>
                                        <div className="currencyValue">
                                            {getTradeDiscountedAmount()}
                                        </div>
                                    </div>
                                </div> */}
                  <div className="formInline dFlex flexNowrap">
                    <div className="formGroup formFloating formInputText">
                      <div className="preInputGroup backColor">
                        <div className="preInputText">%</div>
                      </div>
                      <input
                        type="text"
                        className="formControl"
                        id="amount"
                        placeholder="VAT"
                        value={paymentDetails?.[PAYMENT_DETAILS_FIELDS.VAT]}
                        onChange={(e) =>
                          handlePaymentDetailsUpdate(
                            PAYMENT_DETAILS_FIELDS.VAT,
                            e.target.value
                          )
                        }
                        required
                      />
                      <label for="amount">VAT(%)</label>
                      {false && (
                        <div class="invalidFeedback">
                          Please enter a valid VAT.
                        </div>
                      )}
                    </div>
                    <div className="amountPercentage">
                      <div className="currencyType">BDT</div>
                      <div className="currencyValue">{getVatAmount()}</div>
                    </div>
                  </div>
                  <div className="formGroup formFloating formInputText">
                    <div className="preInputGroup backColor">
                      <div className="preInputText">BDT</div>
                    </div>
                    <input
                      type="text"
                      className="formControl"
                      id="totalamount"
                      placeholder="Total Amount"
                      value={
                        paymentDetails?.[PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT]
                      }
                      readOnly={true}
                      // onChange={(e) => handlePaymentDetailsUpdate(PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT, e.target.value)}
                      required
                    />
                    <label for="totalamount">Total Amount(BDT)</label>
                    {false && (
                      <div class="invalidFeedback">
                        Please enter a valid Total Amount.
                      </div>
                    )}
                  </div>
                  <div className="formGroup formFloating fgrow1 maxWidth">
                    <Select
                      className="formSelect reactSelect"
                      id="floatingSelect"
                      value={{
                        label: convertToTitleCase(
                          paymentDetails?.[PAYMENT_DETAILS_FIELDS.PAYMENT_MODE]
                        ),
                      }}
                      onChange={(option) =>
                        handlePaymentDetailsUpdate(
                          PAYMENT_DETAILS_FIELDS.PAYMENT_MODE,
                          option.name
                        )
                      }
                      options={PAYMENT_MODE_OPTIONS}
                      getOptionLabel={(option) => option?.label}
                      placeholder="Payment Mode"
                      styles={{
                        control: (base) => ({
                          border: 0,
                          display: 'flex',
                          paddingTop: '20px',
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused
                            ? 'rgb(222, 235, 255)'
                            : state.isSelected
                              ? '#FFF'
                              : 'inherit',
                          color: '#212529',
                          '&:hover': {
                            backgroundColor: state.isSelected
                              ? '#DEEBFF'
                              : 'rgb(222, 235, 255)',
                          },
                        }),
                      }}
                      // menuIsOpen={true}
                      isClearable
                    />
                    <label for="floatingSelect">Payment Mode</label>
                    {isFieldErrorVisible &&
                      !paymentDetails?.[
                        PAYMENT_DETAILS_FIELDS.PAYMENT_MODE
                      ] && (
                        <div class="invalidFeedback">
                          Please choose Payment Mode.
                        </div>
                      )}
                  </div>
                  {paymentDetails?.[PAYMENT_DETAILS_FIELDS.PAYMENT_MODE] ===
                    'CASH_CARD' && (
                    <div className="formInline dFlex flexNowrap">
                      <div className="formGroup formFloating formInputText fgrow1">
                        <div className="preInputGroup backColor">
                          <div className="preInputText">BDT</div>
                        </div>
                        <input
                          type="text"
                          className="formControl"
                          id="amountCash"
                          placeholder="Amount in Cash"
                          value={
                            paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT_CASH]
                          }
                          onChange={(e) =>
                            handlePaymentDetailsUpdate(
                              PAYMENT_DETAILS_FIELDS.AMOUNT_CASH,
                              e.target.value
                            )
                          }
                          required
                        />
                        <label for="amountCash">Amount in Cash</label>
                        {false && (
                          <div class="invalidFeedback">
                            Please enter a valid Cash amount.
                          </div>
                        )}
                      </div>
                      <div className="formGroup formFloating formInputText fgrow1 ml-4">
                        <div className="preInputGroup backColor">
                          <div className="preInputText">BDT</div>
                        </div>
                        <input
                          type="text"
                          className="formControl"
                          id="amountCard"
                          placeholder="Amount in Card"
                          value={
                            paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT_CARD]
                          }
                          onChange={(e) =>
                            handlePaymentDetailsUpdate(
                              PAYMENT_DETAILS_FIELDS.AMOUNT_CARD,
                              e.target.value
                            )
                          }
                          required
                        />
                        <label for="amountCard">Amount in Card</label>
                        {false && (
                          <div class="invalidFeedback">
                            Please enter a valid Card Amount.
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </form>
              )}
            </div>
          </SideDrawer>
        )}
        {/** online sales order sideDrawer */}
        {onlineDrawerOpen && (
          <SideDrawer
            handleDrawerToggle={() => handleOnlineDrawerToggle()}
            open={onlineDrawerOpen}
            drawerButton={
              permissions?.features?.[PERMISSION_FEATURE.SALES] ===
              PERMISSION_TYPE.MANAGE
            }
            buttonText="CONFIRM"
            holdButton={
              permissions?.features?.[PERMISSION_FEATURE.SALES] ===
              PERMISSION_TYPE.MANAGE
            }
            holdButtonText="CANCEL"
            drawerHeading="Add New Sales"
            handleClick={() => {
              handleOnlineOrderNextClick()
            }}
            handleHoldClick={() => {
              confirmOnlineSalesOrder(SALES_TYPE.CANCELLED)
            }}
          >
            <WizardSteps
              wizardState={wizardState}
              onStepClick={(step) => onOnlineSalesWizardStepClick(step)}
            />
            <div className="wizardFieldset">
              {serverError && (
                <div class="invalidFeedback mb-4">{serverError}</div>
              )}
              {onlineSalesStage === ONLINE_SALES_STAGES.PRODUCT_DETAILS && (
                <div className="salesOnline">
                  <div className="viewProductWrap">
                    <div className="viewProductHeader">
                      <div className="headerRow dFlex jcSpaceBetween aiCenter">
                        <div className="ProductUniqueTag">
                          {salesData?.invoice_number}
                        </div>
                        <div className="headerRowRight dFlex flexColumn">
                          {formatDate(salesData?.created_at)}{' '}
                          <small>{formatTime(salesData?.created_at)}</small>
                        </div>
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <div className="contactDetailsRow dFlex jcSpaceBetween">
                        <div className="productSupplierName">DG ePharma</div>

                        <div className="productSupplierName">
                          {salesData.type !== 'IN_STORE' ? (
                            <a href={`tel:+${'09606501155'}`}>
                              <CallIcon />
                            </a>
                          ) : (
                            salesData?.customer?.mobile_no
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="prescriptionImages">
                      <div className="prescriptionImagesWrap dFlex">
                        {salesData?.files?.map((file) => {
                          return (
                            <div className="prescriptionImage">
                              <a
                                download={file?.name}
                                target="_blank"
                                href={file.url}
                                title={file?.name}
                                rel="noreferrer"
                              >
                                <img src={file?.url} alt={file?.name} />
                              </a>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <table className="table onlineSales">
                      <thead>
                        <tr>
                          <td width={`${isMobile ? '50%' : '60%'}`}>
                            Medicine
                          </td>
                          <td width={`${isMobile ? '70%' : '20%'}`}>Qty</td>
                          <td
                            className="strong"
                            width={`${isMobile ? '70%' : '20%'}`}
                          >
                            Amount
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {productDetailsArray?.map((product) => {
                          return (
                            <>
                              <tr>
                                <td>
                                  <div>
                                    {formatProductListLabel({
                                      name: product?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME],
                                      size: product?.size,
                                      dose: product?.[PRODUCT_DETAIL_FIELDS.DOSE],
                                      strength: product?.strength,
                                      category: product?.category || product?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY],
                                    })}
                                  </div>
                                  <div className="mt-2">
                                    {product?.inventory?.barcode}
                                    {`(Batch - ${
                                      product?.[
                                        PRODUCT_DETAIL_FIELDS
                                          .SELECTED_BATCH_DETAILS
                                      ]?.[PRODUCT_DETAIL_FIELDS.BATCH_NUMBER]
                                    }, Expiry - ${formatDate(
                                      product?.[
                                        PRODUCT_DETAIL_FIELDS
                                          .SELECTED_BATCH_DETAILS
                                      ]?.[PRODUCT_DETAIL_FIELDS.EXPIRY_DATE]
                                    )})
                                                                `}
                                  </div>
                                </td>
                                <td>
                                  <span>
                                    {product[PRODUCT_DETAIL_FIELDS.QUANTITY]}
                                  </span>
                                </td>
                                <td>
                                  <span className="strong">
                                    BDT{' '}
                                    {product[
                                      PRODUCT_DETAIL_FIELDS.FINAL_PRICE
                                    ] * product[PRODUCT_DETAIL_FIELDS.QUANTITY]}
                                  </span>
                                </td>
                              </tr>
                            </>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {onlineSalesStage === ONLINE_SALES_STAGES.PAYMENT_DETAILS && (
                <div className="salesOnline">
                  <div className="viewProductWrap">
                    <div className="viewProductHeader">
                      <div className="headerRow dFlex jcSpaceBetween aiCenter">
                        <div className="ProductUniqueTag">
                          {salesData?.invoice_number}
                        </div>
                        <div className="headerRowRight dFlex flexColumn">
                          {formatDate(salesData?.created_at)}{' '}
                          <small>{formatTime(salesData?.created_at)}</small>
                        </div>
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <div className="contactDetailsRow dFlex">
                        <div className="productSupplierName">DG ePharma </div>
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <table
                        className="table productPrice pt-4"
                        cellPadding={2}
                        cellSpacing={2}
                      >
                        <tbody>
                          <tr>
                            <td>Amount (BDT)</td>
                            <td align="right">{salesData?.amount}</td>
                          </tr>
                          <tr>
                            <td>VAT</td>
                            <td align="right">{salesData?.vat}</td>
                          </tr>
                          <tr>
                            <td>Discount </td>
                            <td align="right">{salesData?.discount}</td>
                          </tr>
                          <tr>
                            <td className="strong">Total (BDT)</td>
                            <td className="strong" align="right">
                              {salesData?.total_amount}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="disclaimerNotes">
                      <div className="disclaimerNotesHeading">
                        Payment Method
                      </div>
                      <div className="disclaimerNotesDesc">
                        {PAYMENT_MODE_OPTIONS.find(
                          (item) => item.name === salesData.payment_mode
                        )?.label || salesData?.payment_mode}
                      </div>
                    </div>
                  </div>

                  {false && (
                    <div className="dFlex aiCenter flexColumn">
                      <PendingImage />
                      <div className="">
                        Add medications as per prescription to the cart
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </SideDrawer>
        )}

        {/*** online sales with prescription  */}
        {onlinePrescriptionDrawerOpen && (
          <SideDrawer
            handleDrawerToggle={() => handleOnlinePrescriptionDrawerToggle()}
            open={onlinePrescriptionDrawerOpen}
            drawerButton={
              permissions?.features?.[PERMISSION_FEATURE.SALES] ===
              PERMISSION_TYPE.MANAGE
            }
            buttonText={
              addProductActive &&
              onlineSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS
                ? 'Save'
                : 'Confirm'
            }
            holdButton={
              onlineSalesStage === ONLINE_SALES_STAGES.PAYMENT_DETAILS &&
              permissions?.features?.[PERMISSION_FEATURE.SALES] ===
                PERMISSION_TYPE.MANAGE
            }
            holdButtonText="CANCEL"
            drawerHeading="Add New Sales"
            handleClick={
              addProductActive &&
              onlineSalesStage === ADD_SALES_STAGES.PRODUCT_DETAILS
                ? () => handleAddProductClick()
                : () => handleOnlineOrderWithPrescriptionNextClick()
            }
            handleHoldClick={() => {
              confirmOnlineSalesOrder(SALES_TYPE.CANCELLED)
            }}
          >
            <WizardSteps
              wizardState={wizardState}
              onStepClick={(step) => onOnlineSalesWizardStepClick(step)}
            />
            <div className="wizardFieldset">
              {serverError && (
                <div class="invalidFeedback mb-4">{serverError}</div>
              )}
              {onlineSalesStage === ONLINE_SALES_STAGES.PRODUCT_DETAILS && (
                <>
                  <div className="viewProductWrap">
                    <div className="viewProductHeader">
                      <div className="headerRow dFlex jcSpaceBetween aiCenter">
                        <div className="ProductUniqueTag">
                          {salesData?.invoice_number}
                        </div>
                        <div className="headerRowRight dFlex flexColumn">
                          {formatDate(salesData?.created_at)}{' '}
                          <small>{formatTime(salesData?.created_at)}</small>
                        </div>
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <div className="contactDetailsRow dFlex jcSpaceBetween">
                        <div className="productSupplierName">DG ePharma</div>

                        <div className="productSupplierName">
                          {salesData.type !== 'IN_STORE' ? (
                            <a href={`tel:+${'09606501155'}`}>
                              <CallIcon />
                            </a>
                          ) : (
                            salesData?.customer?.mobile_no
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="prescriptionImages">
                      <div className="prescriptionImagesWrap dFlex">
                        {salesData?.files?.map((file) => {
                          return (
                            <div className="prescriptionImage">
                              <a
                                download={file?.name}
                                href={file.url}
                                target="_blank"
                                title={file?.name}
                                rel="noreferrer"
                              >
                                <img src={file?.url} alt={file?.name} />
                              </a>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="addedProductsListWrap">
                      {productDetailsArray?.length < 1 && !addProductActive && (
                        <div className="prescriptionImages">
                          <div className="dFlex aiCenter flexColumn">
                            <PendingImage />
                            <div className="">
                              Add medications as per prescription to the cart
                            </div>
                          </div>
                        </div>
                      )}
                      <ul className="addedProductsList">
                        {productDetailsArray?.length > 0 &&
                          productDetailsArray.map((product) => {
                            return (
                              <li className="addedProduct">
                                <div className="dFlex jcSpaceBetween aiCenter">
                                  <div className="addedProductName">
                                    {formatProductListLabel({
                                      name: product?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME],
                                      size: product?.size,
                                      dose: product?.[PRODUCT_DETAIL_FIELDS.DOSE],
                                      strength: product?.strength,
                                      category: product?.category || product?.[PRODUCT_DETAIL_FIELDS.MEDICAL_CATEGORY],
                                    })}
                                  </div>
                                  <div className="addedProductAction dFlex">
                                    <div
                                      className="trashIcon"
                                      onClick={() =>
                                        setDeleteProductPopup(true)
                                      }
                                    >
                                      <TrashIcon />
                                    </div>

                                    <div
                                      className={`toggleArrow ${
                                        product.product_batch_inventory_id ===
                                        addedProductVisibleId
                                          ? 'show'
                                          : 'hide'
                                      }`}
                                      onClick={() => {
                                        if (
                                          product.product_batch_inventory_id ===
                                          addedProductVisibleId
                                        )
                                          setAddedProductVisibleId(undefined)
                                        else
                                          setAddedProductVisibleId(
                                            product.product_batch_inventory_id
                                          )
                                      }}
                                    >
                                      <ArrowDown />
                                    </div>
                                  </div>
                                </div>
                                {deleteProductPopup && (
                                  <PopupCard
                                    header="Delete Product 1?"
                                    body="Lorem ipsum dolor sit t consectetur. Nulla bibendum ac ornare sodales.?"
                                  >
                                    <button
                                      className="btn btnPrimaryOutlined dFlex"
                                      onClick={() =>
                                        setDeleteProductPopup(false)
                                      }
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      className="btn btnPrimary dFlex"
                                      onClick={() =>
                                        handleRemoveProductClick(product)
                                      }
                                    >
                                      Delete
                                    </button>
                                  </PopupCard>
                                )}
                                {addedProductVisibleId ===
                                  product.product_batch_inventory_id && (
                                  <Product
                                    isFieldErrorVisible={isFieldErrorVisible}
                                    handleProductUpdate={(id, key, value) => {
                                      setServerError(undefined)
                                      handleExistingProductUpdate(
                                        id,
                                        key,
                                        value
                                      )
                                    }}
                                    product={product}
                                    isBarcodeDisabled={true}
                                  />
                                )}
                              </li>
                            )
                          })}
                        {addProductActive && (
                          <li className="addedProduct">
                            <Product
                              isFieldErrorVisible={isFieldErrorVisible}
                              handleProductUpdate={(id, key, value) => {
                                setServerError(undefined)
                                handleProductDetailsUpdate(id, key, value)
                              }}
                              clearProduct={() => {
                                setProductDetails(undefined)
                                setAddProductActive(false)
                              }}
                              getProductDetailsByBarcode={(barCode) =>
                                getProductDetailsByBarcode(barCode)
                              }
                              updateProductDetails={(pDetails) =>
                                setProductDetails(pDetails)
                              }
                              product={productDetails}
                            />
                          </li>
                        )}
                      </ul>
                    </div>

                    {!addProductActive && (
                      <div
                        className="addItemButton"
                        onClick={() => setAddProductActive(true)}
                      >
                        <button className="btn btnPrimary dFlex">
                          <AddIcon />
                        </button>
                      </div>
                    )}
                  </div>
                </>
              )}
              {onlineSalesStage === ONLINE_SALES_STAGES.PAYMENT_DETAILS && (
                <div className="salesOnline">
                  <div className="viewProductWrap">
                    <div className="viewProductHeader">
                      <div className="headerRow dFlex jcSpaceBetween aiCenter">
                        <div className="ProductUniqueTag">
                          {salesData?.invoice_number}
                        </div>
                        <div className="headerRowRight dFlex flexColumn">
                          {formatDate(salesData?.created_at)}{' '}
                          <small>{formatTime(salesData?.created_at)}</small>
                        </div>
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <div className="contactDetailsRow dFlex">
                        <div className="productSupplierName">
                          {customerDetails?.[CUSTOMER_FIELDS.NAME]}
                        </div>
                        <div className="productSupplierName">
                          {customerDetails?.[CUSTOMER_FIELDS.PHONE_NUMBER]}
                        </div>
                      </div>
                      <div className="productSupplierAddress dFlex aiCenter">
                        <LocationIcon className="icon" />{' '}
                        {
                          customerDetails?.[CUSTOMER_FIELDS.SHIPPING_ADDRESS]
                        }{' '}
                      </div>
                    </div>
                    <div className="prescriptionImages">
                      <div className="prescriptionImagesWrap dFlex">
                        {salesData?.files?.map((file) => {
                          return (
                            <div className="prescriptionImage">
                              <a
                                download={file?.name}
                                href={file.url}
                                title={file?.name}
                              >
                                <img src={file?.url} alt={file?.name} />
                              </a>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="viewProductHeader">
                      <table
                        className="table productPrice pt-4"
                        cellPadding={2}
                        cellSpacing={2}
                      >
                        <tbody>
                          <tr>
                            <td>Amount (BDT)</td>
                            <td align="right">
                              {salesData?.amount ||
                                paymentDetails?.[PAYMENT_DETAILS_FIELDS.AMOUNT]}
                            </td>
                          </tr>
                          <tr>
                            <td>VAT</td>
                            <td align="right">{salesData?.vat || 0}</td>
                          </tr>
                          <tr>
                            <td>Discount </td>
                            <td align="right">{salesData?.discount || 0}</td>
                          </tr>
                          <tr>
                            <td className="strong">Total (BDT)</td>
                            <td className="strong" align="right">
                              {salesData?.total_amount ||
                                paymentDetails?.[
                                  PAYMENT_DETAILS_FIELDS.TOTAL_AMOUNT
                                ]}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
              {salesData?.status ===
                PRESCRIPTION_ORDER_MILESTONE.PRESCRIPTION_PENDING_ON_CUSTOMER && (
                <div className="mask">
                  <div className="maskData dFlex aiCenter flexColumn">
                    <PendingImage />
                    <div className="">
                      Order confirmation pending from customer
                    </div>
                  </div>
                </div>
              )}
            </div>
          </SideDrawer>
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    salesData: state?.appDataReducer?.salesData,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createSalesAlertAction: (payload) =>
      dispatch(createSalesAlertAction(payload)),
    holdSalesAlertAction: (payload) => dispatch(holdSalesAlertAction(payload)),
    updateSalesAlertAction: (payload) =>
      dispatch(updateSalesAlertAction(payload)),
    onlineSalesOrderConfirmationAlertAction: (payload) =>
      dispatch(onlineSalesOrderConfirmationAlertAction(payload)),
    onlineSalesOrderCancellationAlertAction: (payload) =>
      dispatch(onlineSalesOrderCancellationAlertAction(payload)),
    dispatchSalesDataAction: (payload) => dispatch(salesDataAction(payload)),
    dispatchNewSalesDataAction: (payload) =>
      dispatch(newSalesDataAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sales)
